<template>
  <router-view v-slot="{ Component }">
    <keep-alive>
      <component :is="Component" />
    </keep-alive>
  </router-view>
  <TabBar v-if="showRoute.includes(route.name)" />

  <!-- 全局图片预览组件 -->
  <VueEasyLightbox
    :visible="imageViewer.visible"
    :imgs="imageViewer.images"
    :index="imageViewer.index"
    @hide="imageViewer.hide"
    @change="handleImageChange"
  />
  <!-- 确认弹窗组件 -->
  <ConfirmModal
    :visible="confirm.visible"
    :title="confirm.title"
    :message="confirm.message"
    :confirm-text="confirm.confirmText"
    :cancel-text="confirm.cancelText"
    @confirm="confirm.handleConfirm"
    @cancel="confirm.handleCancel"
  />
  <!-- 视频播放弹窗组件 -->
  <VideoModal
    v-model="videoStore.showVideoModal"
    :video-url="videoStore.currentVideoUrl"
  />
  <!-- 绑定角色弹窗组件 -->
  <BindRoleModal v-model:show="userStore.showBindModal" />
  <!-- 通用提示文案组件 -->
  <Toast :visible="toast.visible" :message="toast.message" :type="toast.type" />
  <!-- 横屏提示组件 -->
  <LandscapeTip />
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";
import { useRoute } from "vue-router";
import TabBar from "./components/TabBar.vue";
import Toast from "./components/common/Toast.vue";
import ConfirmModal from "./components/common/ConfirmModal.vue";
import VideoModal from "./components/modal/VideoModal.vue";
import LandscapeTip from "./components/common/LandscapeTip.vue";
import BindRoleModal from "./components/modal/BindRoleModal.vue";
import VueEasyLightbox from "vue-easy-lightbox";
import {
  useImageViewerStore,
  useToastStore,
  useConfirmStore,
  useVideoStore,
  useUserStore,
} from "./stores";
import { viewPage, pageType } from "./utils/point";
import { getUrlParams } from "./utils/index";
import sdkBridge from "./utils/sdkBridge";
const active = ref(0);
const imageViewer = useImageViewerStore();
const showRoute = ["home", "notice", "profile"];
const route = useRoute();
const toast = useToastStore();
const confirm = useConfirmStore();
const videoStore = useVideoStore();
const userStore = useUserStore();

// 处理图片索引变化
const handleImageChange = (index: number) => {
  imageViewer.index = index;
};

onMounted(() => {
  // webview 横屏检测和自动外跳：RO_台港澳
  if (sdkBridge.runInsdkLandscape() && getUrlParams("gameId") === "386") {
    let link = window.location.href;
    sdkBridge.open(link, 1, 0, 0, 0, 0, 1);
  }
});

viewPage(pageType.FORUM);
</script>
